<template>
  <div :class="modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ badge.badge ? badge.badge.name : ''}}</p>	
      </header>
      
      <section class="modal-card-body has-text-centered ph15">
        <div class="earned-badge-modal-content">
           <figure class="text-center badge-icon">
            <img v-if="badge.badge && badge.badge.icon_url" :src="badge.badge.icon_url" :alt="badge.badge.desc"/>
          </figure>
          <div class="earned-badge-modal-point-type bg-secondary-light is-flex justify-content-between">
            <div v-if="badge.badge && badge.badge.badge_rewards">
              <span class="has-text-weight-semibold">+{{ totalRewardPoints(badge.badge.badge_rewards) }}</span>
              <span class="is-size-10px">REWARD</span>
            </div>
            <div v-if="badge.badge">
              <span class="has-text-weight-semibold"> {{ badge.badge.date_restriction ? 'Limited' : 'Unlimited'}}</span>
              <span class="is-size-10px">TYPE</span>
            </div>
          </div>
          <p class="text-center is-size-12px mt5" v-if="badge.badge_earned_date">Earned On <span class="has-text-weight-semibold">{{ readableFormat(badge.badge_earned_date) }}</span></p>
        </div>
      </section>

      <footer class="modal-card-foot">
        <div class="next-prev-button">
          <button class="button bg-secondary is-large text-white hover-opacity-7 is-full-width" @click.prevent="closeModal()">CLOSE</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import Helpers from '@/Components/Helpers/Helpers';
export default {
  name: 'EarnedBadgeModal',
  data() {
    return {
      modal: false,
      badge: {},
    };
  },
   computed: {
    ...mapGetters({
    }),
   },
  
  mounted() {
    bus.$on('show-modal-user-earned-badge', (payload) => {
      this.modal = payload.modal;
      this.badge = payload.badge;
    })
  },
  
  beforeDestroy() {
    bus.$off('show-modal-user-earned-badge');
  },
  
  methods: {

    closeModal() {
      this.modal = false;
      this.badge = {};
    },

    /**
     * Calculate total reward point
     */
    totalRewardPoints(rewards) {
      return Helpers.getRewardPoints(rewards);
    },

    // Create readable date format
    readableFormat(fulldate) {
        if (_.isEmpty(fulldate)) return;
        let receivedAt = moment(fulldate);
        return receivedAt.format('DD/MM/YYYY');
    },
    ...mapActions({
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>